import axios from "axios";
import { setAlert } from "./alert";
import {
  GET_ARTICLES,
  CREATE_ARTICLE,
  GET_RECENT_ARTICLE,
  CLEAR_ARTICLE,
  ARTICLE_ERROR,
  UPDATE_ARTICLE_LIKES,
  DELETE_ARTICLE,
  GET_ARTICLE,
  ADD_ARTICLE_COMMENT,
  ADD_ARTICLE_REPLY,
  REMOVE_ARTICLE_COMMENT,
  GET_ARTICLE_COMMENTS,
} from "./types";

// Get articles
export const getArticles = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/trending");

    dispatch({
      type: GET_ARTICLES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get articles
export const getRecentArticle = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/trending/articles/recentarticle");

    dispatch({
      type: GET_RECENT_ARTICLE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get article
export const getArticlesById = (userId) => async (dispatch) => {
  dispatch({ type: CLEAR_ARTICLE });
  try {
    const res = await axios.get(`/api/trending/${userId}`);
    dispatch({ type: CLEAR_ARTICLE });

    dispatch({
      type: GET_ARTICLES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

//Create new article
export const createArticle =
  (articletitle, keywordsText, savedData, dataFile) => async (dispatch) => {
    const formData = new FormData();
    formData.append("articleImage", dataFile);
    formData.append("articletitle", JSON.stringify(articletitle));
    formData.append("Keywords", JSON.stringify(keywordsText));
    formData.append("savedData", JSON.stringify(savedData));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/createarticle`, formData, config);

      dispatch({
        type: CREATE_ARTICLE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ARTICLE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Delete article post
export const deleteArticle = (id) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(`/delete_article`, formData, config);

    dispatch({
      type: DELETE_ARTICLE,
      payload: res.data,
    });

    dispatch(setAlert("Article Removed"));
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add article like
export const addArticleLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/trending/like/${id}`);

    dispatch({
      type: UPDATE_ARTICLE_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove article like
export const removeArticleLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/trending/unlike/${id}`);

    dispatch({
      type: UPDATE_ARTICLE_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add comment
export const addComment = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "/api/trending/articlecomment",
      formData,
      config
    );

    dispatch({
      type: ADD_ARTICLE_COMMENT,
      payload: res.data,
    });

    dispatch(setAlert("Comment Added"));
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add reply to article comment
export const addReply = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "/api/trending/articlecomment/articlereply",
      formData,
      config
    );

    dispatch({
      type: ADD_ARTICLE_REPLY,
      payload: res.data,
    });

    dispatch(setAlert("Reply Added"));
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get article comments
export const getArticleComments = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/trending/articlecomments");

    dispatch({
      type: GET_ARTICLE_COMMENTS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: ARTICLE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
